import React, { createContext, useContext, useState } from 'react';
import { openEmail } from '@/utils/emailHelper';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);

  const addItem = (track) => {
    setItems(prev => {
      if (prev.find(i => i.track_id === track.track_id)) return prev;
      return [...prev, track];
    });
  };

  const removeItem = (trackId) => {
    setItems(prev => prev.filter(i => i.track_id !== trackId));
  };

  const clearCart = () => setItems([]);

  const isInCart = (trackId) => items.some(i => i.track_id === trackId);

  const sendLicensingEmail = () => {
    const trackList = items.map(i => `  - ${i.title}${i.featuring ? ` (feat. ${i.featuring})` : ''}`).join('\n');
    openEmail({
      to: 'contact@mail.samtwoentertainment.com',
      subject: 'Song Licensing Request',
      body: `Hello SAMTWO,\n\nI am interested in licensing the following tracks from your catalog:\n\n${trackList}\n\nPlease let me know your standard rates and licensing terms.\n\nBrief Project Details:\n- Type of Media (e.g., Film, Ad, YouTube, Podcast): [Fill in]\n- Budget/Needs: [Fill in]\n\nBest,`
    });
  };

  // Keep generateMailto for backward compat (returns mailto: string)
  const generateMailto = () => {
    const trackList = items.map(i => `  - ${i.title}${i.featuring ? ` (feat. ${i.featuring})` : ''}`).join('\n');
    const subject = encodeURIComponent('Song Licensing Request');
    const body = encodeURIComponent(
      `Hello SAMTWO,\n\nI am interested in licensing the following tracks from your catalog:\n\n${trackList}\n\nPlease let me know your standard rates and licensing terms.\n\nBrief Project Details:\n- Type of Media (e.g., Film, Ad, YouTube, Podcast): [Fill in]\n- Budget/Needs: [Fill in]\n\nBest,`
    );
    return `mailto:contact@mail.samtwoentertainment.com?subject=${subject}&body=${body}`;
  };

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, isInCart, generateMailto, sendLicensingEmail }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
